import { creditsAPI } from './api';

export interface UserCredit {
  id: string;
  user_id: string;
  credits: number;
  membership_type: string;
  membership_expires_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreditTransaction {
  id: string;
  user_id: string;
  amount: number;
  type: string;
  description: string;
  reference_id?: string;
  balance_after: number;
  created_at: string;
}

function emitCreditsUpdated(userId: string, credits?: number) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent('credits-updated', {
      detail: { userId, credits },
    })
  );
}

// 获取用户积分
export async function getUserCredits(userId: string): Promise<{ credits: UserCredit | null; error: string | null }> {
  try {
    const credits = await creditsAPI.getUserCredits(userId);
    return { credits, error: null };
  } catch (error: any) {
    console.error('获取用户积分失败:', error);
    return { credits: null, error: error.message || '获取用户积分失败' };
  }
}

// 扣减用户积分
export async function deductCredits(userId: string, amount: number, description: string, referenceId?: string): Promise<{ success: boolean; error: string | null; newBalance?: number }> {
  try {
    const result = await creditsAPI.deductCredits(userId, amount, description, referenceId);
    const newBalance = (result as any)?.newBalance ?? (result as any)?.credits;
    emitCreditsUpdated(userId, typeof newBalance === 'number' ? newBalance : undefined);
    return { success: true, error: null, newBalance };
  } catch (error: any) {
    console.error('扣减积分失败:', error);
    return { success: false, error: error.message || '扣减积分失败' };
  }
}

// 增加用户积分
export async function addCredits(userId: string, amount: number, description: string, referenceId?: string): Promise<{ success: boolean; error: string | null; newBalance?: number }> {
  try {
    const result = await creditsAPI.addCredits(userId, amount, description, referenceId);
    const newBalance = (result as any)?.newBalance ?? (result as any)?.credits;
    emitCreditsUpdated(userId, typeof newBalance === 'number' ? newBalance : undefined);
    return { success: true, error: null, newBalance };
  } catch (error: any) {
    console.error('增加积分失败:', error);
    return { success: false, error: error.message || '增加积分失败' };
  }
}

// 设置用户积分
export async function setCredits(userId: string, amount: number, description: string): Promise<{ success: boolean; error: string | null }> {
  try {
    // 这里需要实现设置用户积分的API
    return { success: true, error: null };
  } catch (error: any) {
    console.error('设置积分失败:', error);
    return { success: false, error: error.message || '设置积分失败' };
  }
}

// 获取用户积分交易记录
export async function getCreditTransactions(userId: string, limit: number = 50): Promise<{ transactions: CreditTransaction[]; error: string | null }> {
  try {
    const transactions = await creditsAPI.getUserCreditTransactions(userId);
    return { transactions: (transactions || []).slice(0, limit), error: null };
  } catch (error: any) {
    console.error('获取积分交易记录失败:', error);
    return { transactions: [], error: error.message || '获取积分交易记录失败' };
  }
}
